import { ArrowBackRounded, MoreHorizRounded } from '@mui/icons-material'
import { AppBar, Box, Button, ButtonGroup, Typography, styled } from '@mui/material'
import { MouseEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { IRootState } from '../../../redux/types'
import HiddenDesktop from '../styles/HiddenDesktop'
import BrandMobileFilter from './filters/BrandMobileFilter'
import MenuIcons from './icons/MenuIcons'

export const CustomButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: 8,
  paddingBottom: 10,
  textTransform: 'none',
  border: '0px solid transparent',

  '& .MuiButton-startIcon': {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',

    '& svg': {
      color: theme.palette.grey[400],
      fontSize: '24px !important'
    },
    '&.active svg': {
      color: theme.palette.primary.main
    }
  }
}))

const StyledButtonGroup = styled(ButtonGroup)(({ theme }) => ({
  '&.MuiButtonGroup-root': {
    borderRadius: 16,
    gap: 3,
    backgroundColor: theme.palette.grey[50],
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.16)',
    [theme.breakpoints.between('sm', 'md')]: {
      width: 500,
      margin: '0 auto'
    }
  },
  '&..MuiButtonGroup-grouped': {
    minWidth: '20%',
    maxHeight: 71,
    padding: 0,
    border: '0px !important'
  }
}))

function ClientMobileMenu({ menus }: { menus: any }) {
  let navigate = useNavigate()
  const { t } = useTranslation(['global'])

  const [showMenu, setShowMenu] = useState(true)

  const { accepted: acceptedTerms } = useSelector((state: IRootState) => state.term)
  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  useEffect(() => {
    if (localStorage.getItem('accept_terms') === 'true' && authUser !== null && authUser.me && authUser.verification === 1) {
      setShowMenu(false)
    }
  }, [])

  useEffect(() => {
    if (acceptedTerms) {
      setShowMenu(true)
    }
  }, [acceptedTerms])

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isMenuOpen = Boolean(anchorEl)

  const handleProfileMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  return (
    <HiddenDesktop>
      {showMenu && (
        <>
          <AppBar
            position="fixed"
            sx={{ top: 'auto', bottom: 0, padding: 1, backgroundColor: 'transparent', boxShadow: 'none', border: 'none' }}
          >
            <StyledButtonGroup>
              {menus.slice(0, 4).map((menu: any) => (
                <CustomButton
                  key={menu.id}
                  startIcon={
                    <span className={window.location.pathname === menu.path ? 'active' : ''}>
                      <MenuIcons menuCode={menu.code} />
                    </span>
                  }
                  onClick={() => navigate(menu.path)}
                >
                  <Typography variant="caption" color={window.location.pathname === menu.path ? 'primary' : 'textSecondary'}>
                    {t(menu.code)}
                  </Typography>
                </CustomButton>
              ))}
              {menus.length > 3 && (
                <CustomButton
                  startIcon={<MoreHorizRounded />}
                  onClick={handleProfileMenuOpen}
                  classes={{
                    startIcon: ['/comercial', '/seminarios'].includes(window.location.pathname) ? 'active' : ''
                  }}
                >
                  <Typography
                    variant="caption"
                    color={['/comercial', '/seminarios'].includes(window.location.pathname) ? 'primary' : 'textSecondary'}
                  >
                    {t('see-more')}
                  </Typography>
                </CustomButton>
              )}
            </StyledButtonGroup>
          </AppBar>
          <Box display="flex">
            {isMenuOpen && (
              <AppBar
                position="fixed"
                sx={{
                  top: 'auto',
                  bottom: 0,
                  padding: 1,
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  borderBlockColor: 'none',
                  border: 'none'
                }}
              >
                <StyledButtonGroup>
                  <CustomButton
                    fullWidth
                    startIcon={<ArrowBackRounded />}
                    aria-controls={'primary-search-account-menu'}
                    aria-haspopup="true"
                    onClick={handleMenuClose}
                  >
                    <Typography variant="caption" color="textSecondary">
                      {t('back')}
                    </Typography>
                  </CustomButton>
                  {menus.slice(4).map((menu: any) => (
                    <CustomButton
                      key={menu.id}
                      fullWidth
                      startIcon={<MenuIcons menuCode={menu.code} />}
                      onClick={() => navigate(menu.path)}
                      classes={{
                        startIcon: window.location.pathname === menu.path ? 'active' : ''
                      }}
                    >
                      <Typography
                        variant="caption"
                        style={{ lineHeight: '0.85rem' }}
                        color={window.location.pathname === menu.path ? 'primary' : 'textSecondary'}
                      >
                        {t(menu.code)}
                      </Typography>
                    </CustomButton>
                  ))}
                  <BrandMobileFilter theme="client" type="mobile" />
                </StyledButtonGroup>
              </AppBar>
            )}
          </Box>
        </>
      )}
    </HiddenDesktop>
  )
}

export default ClientMobileMenu
